import Bowser from 'bowser';

import type IBowserBrowserList from '../types/IBowserBrowserList.js';
import type IBrowserDetails from '../types/IBrowserDetails.js';

/**
 * Handles browser detection.
 */
export default class BrowserDetection {
	/**
	 * Browser support detection.
	 *
	 * @param browserList Optional browser list in Bowser Format.
	 * @returns Boolean value.
	 */
	public static hasSupport(browserList: IBowserBrowserList): boolean | undefined {
		const browser = Bowser.getParser(window.navigator.userAgent);
		return browser.satisfies(browserList);
	}

	/**
	 * Gets current browser.
	 *
	 * @returns Current browser information.
	 */
	public static getBrowser(): IBrowserDetails {
		const browser = Bowser.getParser(window.navigator.userAgent);
		return browser.getBrowser();
	}

	/**
	 * Gets current platform.
	 *
	 * @returns Current platform name.
	 */
	public static getPlatform(): string | undefined {
		const browser = Bowser.parse(window.navigator.userAgent);
		return browser.platform.type;
	}
}
